import * as api from "@/api/williams/testEvents";
import { DEFAULT_CONTRACTOR_FILTERS } from "../../contractors/hooks";
import { getContractors } from "@/api/williams/contractors";
import { getWeldingSpecialists } from "@/api/williams/users";
import { queryKeys } from "../../queryKeys";
import { TestEvent } from "@/api/williams/testEvents";
import { useQuery, useQueryClient } from "react-query";

export function useTestEvent(eventId?: string) {
  const queryClient = useQueryClient();
  const id = eventId ?? "";

  return useQuery({
    enabled: Boolean(id),
    queryKey: queryKeys.testEvent.single(id),
    queryFn: async () => {
      const data = await api.getTestEventById(id);
      await prefetchMenus();
      return transform(data);
    },
  });

  function transform(data: TestEvent) {
    return {
      ...data,
      // Remove time portion so it works with the HTML date input.
      testEventDate: data.testEventDate?.substring(0, 10),
    };
  }

  function prefetchMenus() {
    const queries = [];

    if (!queryClient.getQueryData(queryKeys.user.weldingSpecialists())) {
      queries.push(queryClient.prefetchQuery(queryKeys.user.weldingSpecialists(), getWeldingSpecialists));
    }
    if (!queryClient.getQueryData(queryKeys.contractor.filter(DEFAULT_CONTRACTOR_FILTERS))) {
      queries.push(
        queryClient.prefetchQuery(queryKeys.contractor.filter(DEFAULT_CONTRACTOR_FILTERS), () => {
          return getContractors(DEFAULT_CONTRACTOR_FILTERS);
        })
      );
    }
    return Promise.all(queries);
  }
}
